const secretsData = {
  cookie: 'GMM_data_access',
  cookieOld: 'GMM_access_token',
  encryt: 'GMM_access_token',
};

export default secretsData;
